<template>
	<b-container class="w-75 text-dark">
		<b-row class="heading p-4">
			<b-col>
				<h3 class="text-center">Welcome!</h3>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	export default
	{
		name: 'home',
		data() { return {}; }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.fade-enter-active, .fade-leave-active
	{
		transition: all 1s;
	}
</style>
